import { RootState } from '@/store/index';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useCobranding = () => {
  const email = useSelector(
    (state: RootState) => state.loginReducer.loggedInUserObj?.email || '',
  );

  const [isCobranding, brandLogo] = useMemo(() => {
    const userDomain = email.split('@')[1];

    if (!!userDomain && userDomain === 'crispinsights.io') {
      return [true, '/crisp.png'];
    }

    if (!!userDomain && userDomain === 'researchactivate.com') {
      return [
        true,
        'https://enumerate-images-mumbai.s3.ap-south-1.amazonaws.com/RESEARCH-ACTIVATE-Black.png',
      ];
    }

    return [false, null];
  }, [email]);

  return { isCobranding, brandLogo };
};

export default useCobranding;
